<template>
  <div class="container">
    <div class="flex-between flex-wrap flex-center" style="height:42px;background:var(--bg1);filter:hue-rotate(-30deg);color:var(--text1);padding:0 10px;box-shadow:0 5px 10px 0 #00000066;border:1px solid var(--border);">
      <div class="flex-wrap flex-center" style="width:33%;justify-content:flex-start;">
        <BaseIcon icon="nbgz" size="20" />
        <div style="margin-left:10px;font-size:16px;">宁波高专企业信息平台 v2.4.5 </div>
      </div>
      <div class="flex-wrap split5" style="flex-grow:1;">
        <template v-for="category in dashboardCategories">
          <div 
            class="flex-wrap flex-center dashboard-category-item"
            :class="{'dashboard-category-item-active':selected_dashboard_category == category.key}"
            @click="selected_dashboard_category = category.key"
            :key="category.key"
          >
            <BaseIcon  class="dashboard-category-item-icon"
             :icon="category.icon || 'md-speedometer'" size="18" />
            <Badge :dot="category.isNew">{{ category.name }}</Badge>
          </div>
        </template>
     
        <!-- <Dropdown v-model="selected_dashboard" v-if="currentDashbordCategory.dashboards && currentDashbordCategory.dashboards.length > 1">
          <div  style="margin-left:20px;background:#222;border-radius:5px;padding:2px 10px;padding-left:15px;cursor:pointer;">
            {{ selected_dashboard_category.name }}
            <BaseIcon icon="down" />
          </div>
          <DropdownMenu slot="list">
            <template v-for="dashboard in category.dashboards">
              <DropdownItem :key="dashboard.key" :name="dashboard.key">{{ dashboard.name }}</DropdownItem>
            </template>
          </DropdownMenu>
        </Dropdown> -->
     
      <!-- <BaseIcon icon="config" size="14" style="margin-left:10px;cursor:pointer;" />
      -->
    </div>
    <div class="flex-wrap">
      <!-- <Input style="width:120px;margin-left:50px;" size="small" placeholder="搜索" search clearable /> -->
      
    </div>
    </div>
    <div style="height:calc(100% - 42px);position:reliative">
      <BaseLayout
        ref="layout"
        :panels="currentDashbord"
        :loading="loading"
        :gutter="20"
        :padding="15"
        border-radius
        style="background:linear-gradient(to right,var(--border),var(--bg3));"
    ></BaseLayout>
  
    </div>
  </div>
  
    
</template>

<script>
import MileStone from '@/components/milestone';
import pageStateMixin from '@/mixins/page_state';
export default {
  mixins:[pageStateMixin],
  components: {MileStone},
  routerOption: {
    as_default: true,
  },
  data() {
    return {
      loading:true,
      selected_dashboard_category:'mine',
      selected_dashboard:'default',
      pageStateFields:['selected_dashboard_category','selected_dashboard'],
    };
  },
  computed: {
    dashboardCategories(){
      const categories = [{
        key:'news',
        name:'新鲜事',
        isNew:false,
        icon:'md-notifications',
        dashboards:[{
          key:'default',
          layout:{
            default:[{
              x:0,y:0,w:6,h:2.5,control:'PanelWeather'
            },{
                x:16, y: 0, w: 8, h: 4, control: 'PanelCActivity', data: {
                  key: 'notice',
                  title: '通知公告',
                  icon: 'md-notifications',
                },
              },{
                x:8, y: 3, w: 8, h: 4, control: 'PanelCExp', data: {
                  key: 'notice',
                  title: '通知公告',
                  icon: 'md-notifications',
                },
              },{
                x:16,y:4,w:8,h:4,control:'PanelMeetingRooms'
              },{
                x:0,y:7,w:16,h:5,control:'PanelCompanyActivity'
              },{
                x:16, y: 8, w: 8, h: 3, control: 'PanelDownload', data: {
                  key: 'notice',
                  title: '通知公告',
                  icon: 'md-notifications',
                },
              },{
                x: 8, y: 0, w: 8, h: 3, control: 'PanelCNotices', data: {
                  key: 'notice',
                  title: '通知公告',
                  icon: 'md-notifications',
                },
              },
              {
                x: 0, y: 2.5, w: 8, h: 4.5, control: 'PanelCRules', data: {
                  key: 'notice',
                  title: '通知公告',
                  icon: 'md-notifications',
                },
              }]
          }
        }]
      },{
        key:'mine',
        name:'我的工作台',
        isNew:false,
        icon:'md-home',
        dashboards:[{
          key:'default',
          name:'默认风格',
          icon:'md-sunlight',
          layout:{
            1500:[{
                x: 0, y: 0, w: 7.5, h: 4.2, control: 'PanelAccelerators',
              },
              {
                x: 15.5, y: 0, w: 8, h: 2.65, control: 'PanelCNotices', data: {
                  key: 'notice',
                  title: '通知公告',
                  icon: 'md-notifications',
                },
              },
              {
                x: 15.5, y: 3.4, w: 8, h: 3.1, control: 'PanelCRules', data: {
                  key: 'notice',
                  title: '通知公告',
                  icon: 'md-notifications',
                },
              },
              {
                x: 0, y: 4.3, w: 7.5, h: 5, control: 'PanelStudy',
              },
              {
                x: 7.5, y: 0, w: 8, h: 4.5, control: 'PanelTasks',
              },
              {
                x: 7.5, y: 4.35, w: 8, h: 6.5, control: 'PanelGroups',
              }],
            default:[{
                x: 0, y: 0, w: 5, h: 4.5, control: 'PanelAccelerators',
              },
              {
                x: 15.5, y: 0, w: 8, h: 2.65, control: 'PanelCNotices', data: {
                  key: 'notice',
                  title: '通知公告',
                  icon: 'md-notifications',
                },
              },
              {
                x: 15.5, y: 3.4, w: 8, h: 5, control: 'PanelCRules', data: {
                  key: 'notice',
                  title: '通知公告',
                  icon: 'md-notifications',
                },
              },
              {
                x: 0, y: 4.5, w: 5, h: 5, control: 'PanelStudy',
              },
              {
                x: 5, y: 0, w: 10.5, h: 4.5, control: 'PanelTasks',
              },
              {
                x: 5, y: 4.5, w: 10.5, h: 6.5, control: 'PanelGroups',
              },
            ]
          }
        }]
      },
     /** {
        key:'department',
        name:'部门管理',
        isNew:false,
        icon:'md-business',
        layout:{
          default:[{
          }]
        }
      },{
        key:'project',
        name:'项目管理',
        isNew:false,
        icon:'md-project',
        layout:{
          default:[{
          }]
        }
      } */
      ]
    
      return categories
    },
    currentDashbordCategory(){
      return this.dashboardCategories.find(v=>v.key == this.selected_dashboard_category);
    },
    currentDashbord(){
      if(!this.currentDashbordCategory || !Array.isArray(this.currentDashbordCategory.dashboards))
        return [];
      let dashboard = this.currentDashbordCategory.dashboards.find(v=>v.key == this.selected_dashboard);
      if(dashboard){
        let default_layout = dashboard.layout.default;
        if(!default_layout)
          throw new Error('默认布局不存在');
        let breakpoints = Object.keys(dashboard.layout).filter(v=>v!=='default')
        breakpoints.sort((a,b)=>a-b);
        let current_breakpoint = breakpoints.find(v=>this.windowWidth <= v);
        if(current_breakpoint){
          return dashboard.layout[current_breakpoint];
        }
        return default_layout;
      }
      return []
    },
    mobile() {
      return this.$store.getters['session/mobile'];
    },
    windowWidth() {
      return this.$store.getters['session/windowWidth'] - (this.$store.getters['session/showAI'] ? 440 : 0);
    },
    session() {
      return this.$store.getters['session/session'];
    },
  },
  mounted(){
    this.$bus.$on('toggle-ai',()=>{
    // 手动触发window.resize
    window.dispatchEvent(new Event('resize'));
    })
    this.$api.afterLogin(()=>{
      setTimeout(()=>{
        this.loading = false
      },500)
     
    })
  }
};
</script>
<style lang="less">
  .dashboard-category-item{
    padding:2px 10px;
    border-bottom-left-radius:5px;
    border-bottom-right-radius:5px;
    cursor:pointer;
    margin-right:10px;
    transition:all 0.3s;
    .dashboard-category-item-icon{
      margin-right:5px;
    }
  }
  .dashboard-category-item:hover{
    filter:brightness(1.1);
    background:#ffffff11;
  }
  .dashboard-category-item-active{
    background:var(--primary);
    border:1px solid var(--border);
    color:#fff;
    padding:15px;
  }
  .dashboard-category-item-active:hover{
    filter:none;
    background:var(--primary);
  }
</style>